import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'

const LandingServicesCard = ({service, link, icon}) => {
    const { t } = useTranslation()

    return (
        <div className="flex items-center justify-center w-full mx-auto">
            <Link to={link}>
                <img src={icon} alt={service} className="bg-white grow w-20 h-32 mx-auto sm:w-24 sm:h-32 md:w-40 md:h-72 lg:w-52 lg:h-72 xl:w-60 xl:h-96"/>
                <div className="text-center sm:text-xl md:text-xl lg:text-xl xl:text-xl">{ t(`${service}`) }</div>
            </Link>
        </div>
    )
}

export default LandingServicesCard